// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 148) return "user-collection.117c148cd49d168ed417.css";
	// return url for filenames based on template
	return "" + chunkId + "." + {"17":"86d843cfeae162989a81","34":"d9a78e3a641942347195","147":"4413271712529a98aad8","524":"e6ad9aa73da8ef7abeba","881":"46f6b8f7f43580be53cc"}[chunkId] + ".css";
};